import { useMediaQuery } from 'react-responsive';
import PrivacyPolicy from './PrivacyPolicy';
import MobilePolicy from './MobilePolicy';

const PrivacyRouter = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 }); // adjust breakpoint if needed

  return isMobile ? <MobilePolicy /> : <PrivacyPolicy />;
};

export default PrivacyRouter;
